// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/browser/forms/Result.scss
// module id = 1177
// module chunks = 0